// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookYourCar-bookGrid-qMqpd {
  display: grid;
  grid-template-columns: 40% 60%;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  padding: 60px 0px;
}

.BookYourCar-iconCss-Y37uh {
  width: 20px;
  padding-right: 6px;
}

.BookYourCar-bookFlex-sS5rI {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: baseline;
      -ms-flex-align: baseline;
          align-items: baseline;
  word-break: break-word;
}

.BookYourCar-paddingLeft-Qridv {
  padding-left: 120px;
}

@media (max-width: 991px) and (min-width: 768px) {
  .BookYourCar-paddingLeft-Qridv {
    padding-left: 60px;
  }
}

@media screen and (max-width: 767px) {
  .BookYourCar-bookGrid-qMqpd {
    grid-template-columns: 100%;
    padding: 60px 0px;
  }

  .BookYourCar-paddingLeft-Qridv {
    padding-left: 0;
    padding-top: 22px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Home/BookYourCar/BookYourCar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,2BAAqB;MAArB,wBAAqB;UAArB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".bookGrid {\n  display: grid;\n  grid-template-columns: 40% 60%;\n  align-items: center;\n  padding: 60px 0px;\n}\n\n.iconCss {\n  width: 20px;\n  padding-right: 6px;\n}\n\n.bookFlex {\n  display: flex;\n  align-items: baseline;\n  word-break: break-word;\n}\n\n.paddingLeft {\n  padding-left: 120px;\n}\n\n@media (max-width: 991px) and (min-width: 768px) {\n  .paddingLeft {\n    padding-left: 60px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .bookGrid {\n    grid-template-columns: 100%;\n    padding: 60px 0px;\n  }\n\n  .paddingLeft {\n    padding-left: 0;\n    padding-top: 22px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bookGrid": `BookYourCar-bookGrid-qMqpd`,
	"iconCss": `BookYourCar-iconCss-Y37uh`,
	"bookFlex": `BookYourCar-bookFlex-sS5rI`,
	"paddingLeft": `BookYourCar-paddingLeft-Qridv`
};
module.exports = ___CSS_LOADER_EXPORT___;
